/**
 * Compact 8-dot stepper that mirrors the mobile `CustomSteper`. Pure
 * visual — no clicks, just a progress indicator across the top of the
 * flow.
 */

import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";

export default function DemoStepDots({ total, current }) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.75,
        mb: 2,
        flexWrap: "wrap",
      }}
    >
      {Array.from({ length: total }, (_, i) => {
        const idx = i + 1;
        const active = idx <= current;
        return (
          <Box
            key={idx}
            sx={{
              height: 6,
              flexGrow: 1,
              minWidth: 18,
              borderRadius: 999,
              bgcolor: active
                ? theme.palette.primary.main
                : theme.palette.divider,
              transition: "background-color 200ms ease",
            }}
          />
        );
      })}
    </Box>
  );
}

DemoStepDots.propTypes = {
  total: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
};
